'use client';

import React from 'react';

interface AppLogoProps {
  size?: number;
  variant?: 'default' | 'white' | 'dark';
  className?: string;
}

export function NexoraMark({ size = 36, variant = 'default', className = '' }: AppLogoProps) {
  const isWhite = variant === 'white';
  const isDark = variant === 'dark';

  const bgFill = isWhite ? 'rgba(255,255,255,0.18)' : isDark ? '#0A3D3D' : '#0F5C5C';
  const bgStroke = isWhite ? 'rgba(255,255,255,0.35)' : isDark ? 'rgba(201,168,76,0.5)' : 'rgba(201,168,76,0.4)';
  const letterColor = '#FFFFFF';
  const accentColor = isWhite ? 'rgba(255,255,255,0.9)' : '#C9A84C';
  const glowId = `glow-${variant}-${size}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <linearGradient id={`bg-grad-${variant}`} x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={isWhite ? 'rgba(255,255,255,0.25)' : '#1A8A8A'} />
          <stop offset="100%" stopColor={isWhite ? 'rgba(255,255,255,0.08)' : '#072828'} />
        </linearGradient>
        <filter id={glowId} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="1.5" result="blur" />
          <feComposite in="SourceGraphic" in2="blur" operator="over" />
        </filter>
      </defs>

      {/* Outer ring */}
      <circle cx="22" cy="22" r="20.5" stroke={bgStroke} strokeWidth="1" fill="none" />

      {/* Main circle background */}
      <circle cx="22" cy="22" r="18" fill={`url(#bg-grad-${variant})`} />
      <circle cx="22" cy="22" r="18" fill={bgFill} />

      {/* Inner accent ring */}
      <circle cx="22" cy="22" r="15" stroke={isWhite ? 'rgba(255,255,255,0.12)' : 'rgba(201,168,76,0.2)'} strokeWidth="0.75" fill="none" />

      {/* N letter mark — stylized */}
      <path
        d="M14 30V14L22 26V14M22 26V30M30 14V30"
        stroke={letterColor}
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        filter={`url(#${glowId})`}
      />

      {/* Accent dot */}
      <circle cx="30" cy="14" r="3" fill={accentColor} />
      <circle cx="30" cy="14" r="1.5" fill={isWhite ? 'rgba(255,255,255,0.5)' : '#E8C96A'} />
    </svg>
  );
}

export default function AppLogo({ size = 36, variant = 'default', className = '' }: AppLogoProps) {
  return <NexoraMark size={size} variant={variant} className={className} />;
}
